module.exports = __webpack_public_path__ + "static/crane_header-14ce516a10ca18b1d7e96b551725cd6d.png";